import { FC, memo, useRef } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { DEFAULT_PAGE_COLOR } from '../../../constants/spotify';
import { MobileSearchBar } from '../../../components/MobileSearchBar';
import { SearchHeader } from './header';
import useIsMobile from '../../../utils/isMobile';

interface SearchPageProps {
  container: React.RefObject<HTMLDivElement | null>;
}

export const SearchContainer: FC<SearchPageProps> = memo((props) => {
  const isMobile = useIsMobile();
  const ref = useRef<HTMLDivElement>(null);
  const params = useParams<{ search?: string }>();
  const isSearchEmpty = !params.search;

  return (
    <div ref={ref}>
      {isMobile && (
        <div className='mobile-search-wrapper' style={{ padding: '16px 20px 0 20px' }}>
          <MobileSearchBar showTitle={isSearchEmpty} />
        </div>
      )}
      {params.search ? (
        <SearchHeader color={DEFAULT_PAGE_COLOR} sectionContainer={ref} container={props.container} />
      ) : null}
      <div className={`Search-Page ${isSearchEmpty ? 'browse-view' : ''}`}>
        <Outlet />
      </div>
    </div>
  );
});

SearchContainer.displayName = 'SearchContainer';

export default SearchContainer;
